<div class="warranty-part">
  <!-- header -->
  <div class="warranty-header mb-0">
    <div class="ui-g-12 flex-between-center p-0">
      <div class="flex-start-center width-100p">
        <div class="width-100p p-relative font-600 font-16 mt-1">
          {{ isEditMode ? 'Edit' : 'Create'}} Warranty
        </div>
      </div>
      <i id="close-dialog" class="far fa-times pointer dialog-close" (click)="handleClose(false)"></i>
    </div>
  </div>

  <!-- body -->
  <div class="warranty-body flex-column" [ngClass]="{'min-h-0': !isWarrantyPartType}" *ngIf="!isLoading">
    <div class="ui-g-12 p-0 input-control-container">
      <div class="ui-g-6 p-0 flex-start-center">
        <div class="width-100p pr-2 primary-active-border">
          <div class="d-flex">
            <label class="label-heading font-13 font-600">Warranty Name</label>
          </div>

          <app-input id="warranty-name" type="text" placeholder="Enter warranty name*" theme="border" [fontSize]="14"
            name="name" [autoFocus]="true" [value]="warranty.title" [maxLength]="50" [isInvalid]="warranty?.titleError"
            (appChange)="handleChange('title', $event)" (appFocus)="warranty.titleError = false">
          </app-input>
        </div>
      </div>

      <div class="ui-g-6 p-0 flex-start-center warranty-add-auto-complete" *ngIf="!isWarrantyPartType">
        <div class="width-100p pl-1 primary-active-border">
          <div class="flex-row">
            <label class="label-heading font-13 font-600">
              Tire Type
              <i class="far fa-info-circle pl-1 pointer" tooltipPosition="top"
                pTooltip="Select a tire type category that this warranty will cover."></i>
            </label>
          </div>

          <app-auto-complete id="warranty-tire-type" listId="warranty-tire-type-list" placeholder="Select Tire Type"
            field="name" scrollHeight="180px" theme="border" [hasError]="warranty?.itemTypeError"
            [isInvalid]="warranty?.itemTypeError" [disabled]="false" [hasEditableField]="false"
            [hasFutureSelectionField]="false" [closeOnSelection]="true" [isDropdownIconVisible]="true"
            [hasStaticUnassignedFiled]="false" [suggestions]="warrantySuggestions" [listItemFontSize]="14"
            [fontSize]="14" [value]="warranty?.type?.name" [isClearIconVisible]="warranty?.type?.name"
            (appSelect)="onWarrantyTypeSelect($event); warranty.itemTypeError = false;"
            (appCompletedMethod)="onWarrantyTypeSearch($event)" (appClear)="onClearWarrantyTypeSuggestion()">
          </app-auto-complete>
        </div>
      </div>

      <div class="ui-g-6 p-0 flex-start-center warranty-add-auto-complete" *ngIf="isWarrantyPartType">
        <div class="width-100p pl-1 primary-active-border">
          <div class="flex-row">
            <label class="label-heading font-13 font-600">
              Part Type
              <i class="far fa-info-circle pl-1 pointer" tooltipPosition="top"
                pTooltip="Select a part type category that this warranty will cover."></i>
            </label>
          </div>

          <app-auto-complete id="warranty-part-type" listId="warranty-part-type-list" placeholder="Select Part Type"
            field="name" scrollHeight="180px" theme="border" [hasError]="warranty?.itemTypeError"
            [isInvalid]="warranty?.itemTypeError" [disabled]="false" [hasEditableField]="false"
            [hasFutureSelectionField]="false" [closeOnSelection]="true" [isDropdownIconVisible]="true"
            [hasStaticUnassignedFiled]="false" [suggestions]="warrantySuggestions" [listItemFontSize]="14"
            [fontSize]="14" [value]="warranty?.type?.name" [isClearIconVisible]="warranty?.type?.name"
            (appSelect)="onWarrantyTypeSelect($event); warranty.itemTypeError = false;"
            (appCompletedMethod)="onWarrantyTypeSearch($event)" (appClear)="onClearWarrantyTypeSuggestion()">
          </app-auto-complete>
        </div>
      </div>
    </div>

    <!-- Covered Brand and Product Line -->
    <div class="ui-g-12 p-0 input-control-container" *ngIf="isWarrantyPartType">
      <div class="flex-column warranty-covered-section">
        <div class="ui-g-12 p-0 flex-start-center">
          <div class="width-100p pr-2 primary-active-border">
            <div class="d-flex flex-start-center gap-2">
              <label class="label-heading font-14 font-400">
                Select covered Brand &amp; Product Line
                <i class="far fa-info-circle pl-1 pointer" tooltipPosition="top"
                  pTooltip="Parts that match these brands and product lines will automatically be marked Warranty Eligible when added to an estimate or repair order."></i>
              </label>
              <div class="horizontal-border"></div>
            </div>
          </div>
        </div>
        <div class="warranty-product-line-body flex-column">
          <ng-container *ngFor="let covProduct of warranty.coveredProducts; let covIndex = index;">
            <div class="ui-g-12 p-0 input-control-container">
              <div class="ui-g-6 p-0 flex-start-center warranty-add-auto-complete">
                <div class="width-100p pr-2 primary-active-border">
                  <app-auto-complete id="warranty-brand" listId="warranty-brand-list" placeholder="Brand"
                    [isLoading]="covProduct?.isLoadingBrands" field="brandName" scrollHeight="180px" theme="border"
                    [hasError]="covProduct?.brandError" [isInvalid]="covProduct?.brandError" [disabled]="false"
                    [hasEditableField]="false" [hasFutureSelectionField]="false" [closeOnSelection]="true"
                    [isDropdownIconVisible]="true" [hasStaticUnassignedFiled]="false"
                    [suggestions]="covProduct?.brandWarrantySuggestion" [listItemFontSize]="14" [fontSize]="14"
                    [value]="covProduct?.brand?.brandName" [isClearIconVisible]="covProduct?.brand?.brandName"
                    (appSelect)="onCoveredBrandProductLineSelect('brand', $event, covIndex); covProduct.brandError = false;"
                    (appCompletedMethod)="onCoveredBrandSearch($event, covIndex)"
                    (appClear)="onClearBrandSussgestion(covIndex)">
                  </app-auto-complete>
                </div>
              </div>

              <div class="ui-g-6 p-0 flex-start-center warranty-add-auto-complete">
                <div class="width-100p pl-1 primary-active-border">
                  <app-auto-complete id="warranty-product-line" listId="warranty-product-line-list"
                    placeholder="Product Line" field="subCategoryName" scrollHeight="180px" theme="border"
                    [isLoading]="covProduct?.isLoadingSubBrands" editableItemIdKey="subCategoryId"
                    editFieldLabel="Create Product Line" [hasError]="covProduct?.subBrandError"
                    [isInvalid]="covProduct?.subBrandError" [disabled]="!covProduct?.brand?.brandName"
                    [showSelectedValue]="false" [hasEditableField]="true" [hasFutureSelectionField]="false"
                    [closeOnSelection]="true" [isDropdownIconVisible]="true" [hasStaticUnassignedFiled]="false"
                    [suggestions]="covProduct?.productLineSuggestions" [listItemFontSize]="14" [fontSize]="14"
                    (appSelect)="onCoveredBrandProductLineSelect('productLine', $event, covIndex); covProduct.subBrandError = false;"
                    (appUpdateItem)="onProductLineUpdate($event, covIndex)"
                    (appSave)="onSaveProductLine($event, covIndex)">
                    <ng-template let-item let-editItem="editItem" appTemplate="item">
                      <div class="tag-item flex-between-center">
                        <div>{{ item?.subCategoryName }}</div>
                        <div class="tag-item-action flex-end-center" *ngIf="!item?.isDefault">
                          <i class="far fa-trash p-1 mr-2"
                            (click)="$event.stopPropagation(); onDeleteProductLine(item,covIndex)"></i>
                          <i class="far fa-pencil p-1 mr-2" (click)="$event.stopPropagation(); editItem(item)"></i>
                        </div>
                      </div>
                    </ng-template>
                  </app-auto-complete>
                </div>
                <span class="ml-2 pointer" (click)="removeCoveredBrandProductLine(covIndex)" *ngIf="covIndex > 0">
                  <i class="fa fa-trash font-14 font-gray-35"></i>
                </span>
              </div>
            </div>

            <div class="flex-row gap-2 flex-wrap" *ngIf="covProduct?.selectedProductLines?.length">
              <span class="selected-product-lines font-14 font-600"
                *ngFor="let selecedItem of covProduct?.selectedProductLines; let selectedITemIndex = index;">
                {{selecedItem?.subCategoryName}}
                <i class="far fa-times pointer pl-1" (click)="removeSelectedItem(covIndex, selectedITemIndex)"></i>
              </span>
            </div>
          </ng-container>
        </div>


      </div>
    </div>

    <div class="ui-g-12 p-0" *ngIf="isWarrantyPartType">
      <button class="btn btn-warranty-add w-100" (click)="addAnotherCoverdProductLine()">
        <div class="flex-center-center gap-2">
          <i class="far fa-plus-circle"></i>
          <span class="font-14 font-600">Add another Brand &amp; Product Line</span>
        </div>
      </button>
    </div>
  </div>

  <div class="warranty-body flex-center-center" [ngClass]="{'min-h-0': !isWarrantyPartType}" *ngIf="isLoading">
    <span class="flex-row font-18">
      <i class="fa fa-spinner rotate"></i>
    </span>

  </div>

  <div class="warranty-footer border-top-lightest">
    <div class="ui-g-12 p-0 flex-end-center gap-2">
      <button class="btn btn-white" (click)="handleClose(false)">Cancel</button>
      <button class="btn btn-primary" [disabled]="isLoading || isSubmitting" (click)="handleSubmit()">
        {{isEditMode ? 'Save' : 'Create'}}
        <i class="fa fa-spinner rotate" *ngIf="isLoading || isSubmitting"></i>
      </button>
    </div>
  </div>
</div>